const initialState = {
    akasse: false,
    english: false,
    appLoaded: false,
    cpr: null,
    devEnv: null,
    dmValid: false,
    maValid: false,
    educationCourseFreeText: "",
    educationLevel: null,
    childUrl: null,
    educations: null,
    error: false,
    institutes: null,
    campaignCode: null,
    campaignCodeList: [],
    countries: null,
    subscriptions: null,
    maCountries: [],
    funds: [],
    member: null,
    umbracoId: null,
    text: null,
    newsLetterText: "",
    educationLevels: [
        { label: 'Bachelor', value: 50 },
        { label: 'Professionsbachelor', value: 55 },
        { label: 'Kandidat', value: 70 },
        { label: 'Ph.d', value: 80 }
    ],
    newsLetterTextExtra: "",
    consentTextObject: null,
    klMember: false,
    glMember: false,
    steps: null,
    currentComponent: null,
    formType: null, // ma = MA-AKASSE ONLY - dmma = BOTH - dm = MAGISTER ONLY
    subType: null,
    serverResponse: null,
    loadingResponse: false,
    isTrustee: false,
    isCallCenter: false,
    fullFormFormat: false,
    educationLoaded: false,
    educationError: false,
    workLoaded: false,
    workError: false,
    maLoaded: false,
    maError: false,
    scrollOptions: {
        container: 'body',
        easing: 'ease-in',
        duration: 0,
        offset: -60,
        onDone: false
    },
    employerLoading: false,
    employers: [],
    halfMember: false,
    maternity: false,
    jobs: [],
    jobPositions: [],
    jobTypes: [],
    pensionType: 0,
    marketingConsent: false,
    maNotAllowedWarning: false,
    studentsUrl: null,
    title: null,
    subTitle: null,
    selectChoices: [{
            name: "i arbejde",
            english: "working",
            icon: "fa-car-building",
            value: "ordinary",
            active: false,
            description: "",
            subGroupId: "173720001",
            subGroup: "ordinær"
        },
        {
            name: "ledig",
            english: "unemployed",
            icon: "fa-file-search",
            value: "unemployed",
            active: false,
            description: "",
            subGroupId: "173720002",
            subGroup: "Ledige"
        },
        {
            name: "studerende",
            english: "studying",
            icon: "fa-book",
            value: "student",
            active: false,
            description: "",
            subGroupId: "173720003",
            subGroup: "Stud"
        },
        {
            name: "freelancer eller selvstændig",
            english: "freelancer or selfemployed",
            icon: "fa-lightbulb-on",
            value: "freelancer",
            active: false,
            description: "",
            subGroupId: "173720004",
            subGroup: "ordinær"
        },
        {
            name: "pensionist eller på efterløn",
            english: "in need of translation",
            icon: "fa-newspaper",
            value: "retiree",
            active: false,
            description: "",
            subGroupId: "173720005",
            subGroup: "ordinær"
        }
    ],
    components: {
        default: [
            {
                sortOrder: 5,
                name: 'ContactForm',
                text: 'Kontakt',
                english: 'Contact',
                isValid: false,
                isActive: false,
                isGtmShown: false,
                virtualPath: "kontakt"
            },
            {
                sortOrder: 10,
                name: 'InfoForm',
                text: 'Oplysninger',
                english: 'Info',
                isValid: false,
                isActive: false,
                isGtmShown: false,
                virtualPath: "oplysninger"
            },
            {
                sortOrder: 20,
                name: 'EducationForm',
                text: 'Uddannelse',
                english: 'Education',
                isValid: false,
                isActive: false,
                isGtmShown: false,
                virtualPath: "uddannelse"
            },
            {
                sortOrder: 90,
                name: 'ConfirmForm',
                text: 'Godkendelse',
                english: 'Confirm',
                isValid: false,
                isActive: false,
                isGtmShown: false,
                virtualPath: "godkendelse"
            }
        ],
        ordinary: [{
            sortOrder: 30,
            name: 'WorkForm',
            text: 'Arbejde',
            english: 'Work',
            isValid: false,
            isActive: false,
            isGtmShown: false,
            virtualPath: "arbejde"
        }],
        akasse: [{
            sortOrder: 40,
            name: 'AkasseForm',
            text: 'A-kasse',
            english: 'Insurance fund',
            isValid: false,
            isActive: false,
            isGtmShown: false,
            virtualPath: "akasse"
        }, ],
    },
    presents: null,
    campaignConditions: null,
    selectedGift: null,
    antiforgeryToken: null,
    pageViewId: null,
    adversusWebhookEnabled: false,
    enrollmentGuid: null,
    //sent with the submission for server-side logging only, never personal data
    clientDiagnostics: {
        startedAt: null,
        stepHistory: [],
        submitAttempts: 0
    },
    adversusData:{
        guid: null,
        name: null,
        phone: null,
        email: null,
        hostname: null,
        subtype: null,
        campaign: null,
        isCompleted: false
    },
    workingAreas: [],
    fuseSearch: null,
    workFormState:{
        workplaceNotInList: false,
        workplaceSelected: false,
        loadingCompanies: false,
        loadingCompleted: false,
        foundedCompany: null,
        foundedCompanyWorkplaces: [],
        foundedWorkplaceNotInList: false,
        isPublicWorkplace: false,
        isAcWorkplace: false,
        workplaceHasJobPositionStructure: null,
        canBeManager: null,
        followsOtherCollectiveAgreement: null,
    }
};

export default Object.assign({}, initialState);